/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { LoginLocalRequestToJSON, RegisterUserLocalRequestToJSON, RegistrationResultFromJSON, ResetPasswordRequestToJSON, SuccessfullApiResponseFromJSON, } from '../models';
/**
 *
 */
export class UserAuthApi extends runtime.BaseAPI {
    /**
     */
    apiUserAuthChangepasswordPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/UserAuth/changepassword`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiUserAuthChangepasswordPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiUserAuthChangepasswordPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiUserAuthChangepasswordwithtokenPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/UserAuth/changepasswordwithtoken`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ResetPasswordRequestToJSON(requestParameters.resetPasswordRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiUserAuthChangepasswordwithtokenPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiUserAuthChangepasswordwithtokenPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiUserAuthConfirmemailGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            if (requestParameters.email !== undefined) {
                queryParameters['email'] = requestParameters.email;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/UserAuth/confirmemail`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiUserAuthConfirmemailGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiUserAuthConfirmemailGetRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    apiUserAuthGenerateTestActivationUrlGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.email !== undefined) {
                queryParameters['email'] = requestParameters.email;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/UserAuth/GenerateTestActivationUrl`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiUserAuthGenerateTestActivationUrlGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiUserAuthGenerateTestActivationUrlGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiUserAuthLoginPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/UserAuth/login`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: LoginLocalRequestToJSON(requestParameters.loginLocalRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationResultFromJSON(jsonValue));
        });
    }
    /**
     */
    apiUserAuthLoginPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiUserAuthLoginPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiUserAuthLogoutPostRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/UserAuth/logout`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiUserAuthLogoutPost(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiUserAuthLogoutPostRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiUserAuthRegisterPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/UserAuth/register`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: RegisterUserLocalRequestToJSON(requestParameters.registerUserLocalRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationResultFromJSON(jsonValue));
        });
    }
    /**
     */
    apiUserAuthRegisterPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiUserAuthRegisterPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiUserAuthResendActivationLinkGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.email !== undefined) {
                queryParameters['email'] = requestParameters.email;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/UserAuth/ResendActivationLink`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiUserAuthResendActivationLinkGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiUserAuthResendActivationLinkGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiUserAuthSendpasswordtokenPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.email !== undefined) {
                queryParameters['email'] = requestParameters.email;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/UserAuth/sendpasswordtoken`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiUserAuthSendpasswordtokenPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiUserAuthSendpasswordtokenPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
